(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
	}

	document.addEventListener('shopify:section:load', function (e) {
		swiperInit();
	});

	window.addEventListener('resize', function () {
		$('.product-section .js-media-list').each(function () {
			this.swiper.destroy();
		});
		$('.product-section .js-media-sublist').each(function () {
			this.swiper.destroy();
		});

		swiperInit();
	});

	swiperInit();
})();
document.addEventListener("DOMContentLoaded", function () {
  const toggleLinks = document.querySelectorAll(".toggle-description");

  toggleLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const container = this.closest(".collection-description");
      const shortDesc = container.querySelector(".short-description");
      const fullDesc = container.querySelector(".full-description");

      if (shortDesc.style.display !== "none") {
        shortDesc.style.display = "none";
        fullDesc.style.display = "block";
        this.textContent = "Mostra di meno";
      } else {
        shortDesc.style.display = "block";
        fullDesc.style.display = "none";
        this.textContent = "Mostra di più";
      }
    });
  });
});